import { routerPostCall } from '../../axios';

export const getQuotationEmailURL = `/accounts/quote/send-quotation-pdf`;
const getQuotationEmail = (state, params) => {
    const url = getQuotationEmailURL;
    return routerPostCall(state, url, params);
};
export default { getQuotationEmail };
